<template>
  <div class="forms__field-wrapper" :class="extraClasses">
    <p class="field-description" v-if="fieldData.description" v-html="fieldData.description"/>
    <p class="forms__help-text" v-if="helpText.length > 0">{{ helpText }}</p>
    <div class="input-wrapper" :class="{ 'error': showFormError,  'required': required }">
      <textarea class="input" 
        :placeholder="label" 
        :id="id"
        :required="required"
        v-model="value"/>
      <label class="floating-label" :for="id">{{ label }}</label>
      <p class="forms__error-message" v-if="showFormError" v-t="'errors.required_field'" role="alert"/>
    </div>
  </div>
</template>

<script>
import AbstractField from "@/util/AbstractField";

export default {
  name: 'text-area',
  mixins: [AbstractField],
}
</script>